<template>
  <div>
    <h2
      class="font-[Poppins] font-black text-[clamp(24px,3.5vw,34px)] text-[#191c1e] mb-1.5 tracking-[-0.5px]"
    >
      Navigeringspill
    </h2>
    <p
      class="font-[Plus_Jakarta_Sans] text-[15px] text-[#6c7a77] leading-[1.65] mb-7 max-w-[580px]"
    >
      Glasmorfism-pills för navigering i receptsteg. Används på bildkort och som
      "Tillbaka"-knappar på mörkare bakgrunder.
    </p>

    <PreviewBox label="Mörkt läge — på mörk bakgrund" bg="#191c1e">
      <button
        class="flex items-center gap-2 px-4 py-2.5 rounded-full font-[Poppins] font-bold text-sm text-white cursor-pointer border-none backdrop-blur-sm"
        style="background: rgba(255, 255, 255, 0.15)"
      >
        <ArrowLeft :size="16" /> Tillbaka
      </button>
      <button
        class="flex items-center gap-2 px-4 py-2.5 rounded-full font-[Poppins] font-bold text-sm text-white cursor-pointer border-none backdrop-blur-sm"
        style="background: rgba(255, 255, 255, 0.15)"
      >
        Steg 3 av 6
      </button>
    </PreviewBox>

    <PreviewBox label="Ljust läge — på ljus bakgrund" bg="#f7f9fb">
      <button
        class="flex items-center gap-2 px-4 py-2.5 rounded-full font-[Poppins] font-bold text-sm text-[#191c1e] cursor-pointer border-none"
        style="background: rgba(0, 0, 0, 0.06)"
      >
        <ArrowLeft :size="16" /> Tillbaka
      </button>
    </PreviewBox>

    <CodeBlock :tabs="snippetTabs" />
  </div>
</template>

<script setup>
import { ArrowLeft } from "lucide-vue-next";
import PreviewBox from "../components/PreviewBox.vue";
import CodeBlock from "../components/CodeBlock.vue";

const htmlCode = `<!-- På mörk bakgrund -->
<button class="flex items-center gap-2 px-4 py-2.5 rounded-full font-[Poppins] font-bold text-sm text-white
               border-none backdrop-blur-sm cursor-pointer"
  style="background: rgba(255,255,255,0.15)">
  <ArrowLeft :size="16" /> Tillbaka
</button>

<!-- På ljus bakgrund -->
<button class="flex items-center gap-2 px-4 py-2.5 rounded-full font-[Poppins] font-bold text-sm text-[#191c1e]
               border-none cursor-pointer"
  style="background: rgba(0,0,0,0.06)">
  <ArrowLeft :size="16" /> Tillbaka
</button>`;

const cssCode = `/* På mörk bakgrund (foto/overlay) */
background: rgba(255,255,255,0.15);
backdrop-filter: blur(8px);

/* På ljus bakgrund */
background: rgba(0,0,0,0.06);

/* Form */
border-radius: 9999px;   /* rounded-full */
border: none;

/* Typsnitt */
font-family: 'Poppins', sans-serif;
font-weight: 700;
font-size: 14px;`;

const snippetTabs = [
  { label: "HTML", code: htmlCode },
  { label: "CSS", code: cssCode, lang: "css" },
];
</script>
